<p-progressSpinner class="resy_spinner spinner_in_front change-password-spinner" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex justify-content-center">
    <span class="change-password-message">{{'INFO.CHANGE_PASSWORD' | translate}}</span>
  </div>
  <div class="pb-2">
    <label class="lbl_light_field">{{'LOGIN.PASSWORD'|translate}}
      <i *ngIf="errorModel!=null && errorModel['OldPassword']!=null"
         class="pi pi-exclamation-circle float-end me-1 error_color"
         pTooltip="{{errorModel['OldPassword']|translate}}" tooltipPosition="top"></i>
    </label>
    <p-password [(ngModel)]="changePasswordModel.oldPassword" [feedback]="false" [toggleMask]="true"
                [styleClass]="'p-password p-component p-inputwrapper p-input-icon-right'"
                [id]="'sign_up_password_filed'"
                [inputStyleClass]="'input_field password-input-field'">
    </p-password>
  </div>
  <div class="pb-2">
    <label class="lbl_light_field">{{'INFO.RESET_PASSWORD' | translate}}
      <i *ngIf="errorModel!=null && errorModel['NewPassword']!=null"
         class="pi pi-exclamation-circle float-end me-1 error_color"
         pTooltip="{{errorModel['NewPassword']|translate}}" tooltipPosition="top"></i>
      <i *ngIf="(changePasswordModel.newPassword !== undefined && !isPasswordValid()) && (errorModel==null || errorModel['NewPassword']==null)"
         class="pi pi-exclamation-circle float-end me-1 error_color"
         pTooltip="{{'INFO.INVALID_PASSWORD' | translate}}" tooltipPosition="top"></i>
    </label>
    <p-password [(ngModel)]="changePasswordModel.newPassword" [toggleMask]="true" [feedback]="false"
                [styleClass]="'p-password p-component p-inputwrapper p-input-icon-right'"
                [id]="'sign_up_password_filed'"
                (click)="openTooltip(t1)" (mouseleave)="closeTooltip(t1)" (mouseenter)="openTooltip(t1)"
                [inputStyleClass]="'input_field password-input-field'" [ngbTooltip]="passwordInfoTooltipContent"
                [animation]="false" [placement]="['right', 'left']" triggers="manual"
                tooltipClass="signup-password-tooltip" #t1="ngbTooltip"
                [autoClose]="false"></p-password>
  </div>
  <div class="pb-2">
    <label class="lbl_light_field">{{'SIGN_UP.CONFIRM_PASSWORD'|translate}}
      <i *ngIf="errorModel!=null && errorModel['ConfirmPassword']!=null"
         class="pi pi-exclamation-circle float-end me-1 error_color"
         pTooltip="{{errorModel['ConfirmPassword']|translate}}" tooltipPosition="top"></i>
    </label>
    <p-password [(ngModel)]="changePasswordModel.confirmNewPassword" [feedback]="false" [toggleMask]="true"
                [styleClass]="'p-password p-component p-inputwrapper p-input-icon-right'"
                [id]="'sign_up_password_filed'"
                [inputStyleClass]="'input_field password-input-field'">
    </p-password>
  </div>
  <div class="d-flex flex-column w-100" style="gap: 10px;">
    <button class="btn_login mt-3 mb-1" (click)="changePassword(changePasswordModel)">{{'SAVE' | translate}}</button>
    <button class="btn_without_color m-0" (click)="cancel()">{{'CANCEL' | translate}}</button>
  </div>
</div>
<ng-template #passwordInfoTooltipContent>
  <div class="password-tooltip-content">
    <span>{{'INFO.PASSWORD_PATTERN_MESSAGE_1' | translate}} </span>
    <span [class.password-rule-checked]="has8Characters()">{{'INFO.PASSWORD_PATTERN_MESSAGE_2' | translate}} </span>
    <span>{{'INFO.PASSWORD_PATTERN_MESSAGE_3' | translate}}</span>
    <ul>
      <li [class.password-rule-checked]="hasUppercaseLetter()">{{'INFO.PASSWORD_1_UPPERCASE' | translate}}</li>
      <li [class.password-rule-checked]="hasLowercaseLetter()">{{'INFO.PASSWORD_1_LOWERCASE' | translate}}</li>
      <li [class.password-rule-checked]="hasSpecialCharacter()">{{'INFO.PASSWORD_SPECIAL_CHAR' | translate}} (:, ?, @..)
      </li>
    </ul>
  </div>
</ng-template>
